import React from "react";
import useAddNewPeriod from "../hooks/useAddNewPeriod";
import t from '../../../helpers/t';
import Biscuit from '../../../../utils/Biscuit';
const AddNewPeriod = ({ currentLocation, currentPrice,select }) => {

  const { handleClick/*, periods*/ } = useAddNewPeriod({ currentLocation,currentPrice,select });
  return (
    <>
      {select === 'price' && currentPrice !== null && currentPrice !== '' &&
          <>
            <button
                id="inb-c-left-bar-add-contingent"
                onClick={e => handleClick(e)}
                className={"button beautify beautify-" + Biscuit.get('user.client_id')}
                style={{minWidth: "100px"}}
            >
              <i className="fi fi-page-add"></i>
              <span>
                      {t('add_${a}', {a: t('price_season_times')})}
                  </span>
            </button>
          </>
      }
              {(select === 'location' || select === 'set') && currentLocation !== null && currentLocation !== '' &&
                 <>
                   <button
                       id="inb-c-left-bar-add-contingent"
                       onClick={e => handleClick(e)}
                       className={"button beautify beautify-" + Biscuit.get('user.client_id')}
                       style={{minWidth: "100px"}}
                   >
                     <i className="fi fi-page-add"></i>
                     <span>
                          {t('add_${a}', {a: t('period')})}
                      </span>
                   </button>
                 </>
             }

    </>
  );
};
export default AddNewPeriod;
